import React, {FC} from 'react';
import type {TabsProps} from 'antd';
import {TabsStyled} from "./styled";

export const Tabs: FC<TabsProps> = ({items, onChange, centered}) => {
    return (
        <TabsStyled destroyInactiveTabPane defaultActiveKey="1" items={items} onChange={onChange} centered={centered}/>
    );
};
